import React from 'react';

interface Chain {
    id: string;
    label: string;
    imageUrl: string;
}

const CHAINS: Chain[] = [
    { id: 'all', label: 'All Chains', imageUrl: '/images/chains/all.png' },
    { id: 'ethereum', label: 'Ethereum', imageUrl: '/images/chains/ethereum.png' },
    { id: 'solana', label: 'Solana', imageUrl: '/images/chains/solana.png' },
    { id: 'base', label: 'Base', imageUrl: '/images/chains/base.png' },
    { id: 'arbitrum', label: 'Arbitrum', imageUrl: '/images/chains/arbitrum.png' },
    { id: 'polygon', label: 'Polygon', imageUrl: '/images/chains/arbitrum.png' }
].map(chain => ({
    ...chain,
    id: chain.id.toLowerCase()
}));

interface ChainFilterProps {
    selectedChain: string;
    onChainSelect: (chainId: string) => void;
}

const ChainFilter: React.FC<ChainFilterProps> = ({ selectedChain, onChainSelect }) => {
    return (
        <div className=" mb-2">
            <div className="mb-1 pb-1 ">
                <span className="text-gray-300 text-sm">Chains</span>
            </div>
            <div className="flex gap-2 overflow-x-auto pb-2">
                <button
                    onClick={() => onChainSelect('all')}
                    className={`
                        px-6 h-10 rounded-lg flex items-center justify-center transition-colors whitespace-nowrap
                        ${selectedChain === 'all' 
                            ? 'bg-purple-500 text-white' 
                            : 'bg-[#0D0B14] text-white'}
                    `}
                >
                    <span className="text-sm font-medium">ALL</span>
                </button>

                <div className="border border-gray-800 rounded-lg flex overflow-hidden">
                    {CHAINS.slice(1).map((chain, index) => (
                        <div
                            key={chain.id}
                            className={`
                                ${index !== CHAINS.length - 2 ? 'border-r border-gray-800' : ''}
                            `}
                        >
                            <button
                                onClick={() => onChainSelect(chain.id)}
                                className={`
                                    h-10 px-4 flex items-center gap-3 transition-colors whitespace-nowrap
                                    ${selectedChain === chain.id 
                                        ? 'bg-purple-500' 
                                        : 'bg-transparent hover:bg-gray-900'}
                                `}
                            >
                                {/* <div className="w-6 h-6 relative bg-gray-800 rounded flex items-center justify-center">
                                    <img
                                        src={chain.imageUrl}
                                        alt={`${chain.label} chain`}
                                        className="w-4 h-4 object-contain"
                                    />
                                </div> */}
                                <span className={`text-sm text-white`}>
                                    {chain.label}
                                </span>
                            </button>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ChainFilter; 